<template>
  <div class="custom-panel">
    <slot class="tab-panel" name="tab-panel">
    </slot>
    <div class="panel-content" :style="{'zIndex':zIndex}" >
      <div class="header" :class="isTopLine?'header-line':''" @mousedown="onmousedown">
        <div class="left">
          <!-- <div class="line"></div> -->
          <div class="title">{{title}}</div>
        </div>
        <slot name="header">
        </slot>
        <div class="right">
          <Icon type="big" name="el-icon-close" @click="onClose"></Icon>
          <!-- <icon-font type="icon-xiala" :class="{'closestatus':isFold}" @click="onFold()" v-if="calFold"/> -->
        </div>
      </div>
      <div class="main" v-show="!isFold" :style="contentStyle">
        <!-- <div class="divider"></div> -->
        <slot class="content" name="content">
        </slot>
        <slot class="footer"  name="footer">
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'CustomPanel',
  props: {
    /**
     * 标题
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * 是否看折叠
     */
    calFold: {
      type: Boolean,
      default: true
    },
    contentStyle: {
      type: Object,
      default: () => {
        return {}
      }
    },
    closeOnPressEscape: {
      type: Boolean,
      default: false
    },
    isTopLine: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['maxZIndex'])
  },
  data () {
    return {
      visible: false,
      // 是折叠
      isFold: false,
      // 位置
      disX: 0,
      dixY: 0,
      // 界面层级
      zIndex: 0
    }
  },

  mounted () {
    document.body.ondragenter = function (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    window.addEventListener('keydown', (event) => {
      switch (event.key) {
        case 'Escape':
          if (this.closeOnPressEscape) {
            this.onClose()
          }
          break
        default:
          return false
      }
    }, true)
  },

  methods: {
    onClose () {
      this.$emit('onClose')
      this.unTop()
    },
    // 界面置顶
    top () {
      if (this.zIndex >= this.maxZIndex) {
        return
      }
      this.zIndex = this.maxZIndex
      this.$store.dispatch('setMaxZIndex', this.maxZIndex + 1)
    },
    unTop () {
      if (this.zIndex < this.maxZIndex - 1) {
        return
      }
      this.$store.dispatch('setMaxZIndex', this.maxZIndex - 1)
      this.zIndex = 0
    },
    onFold () {
      this.isFold = !this.isFold
    },
    // 展开/折叠界面
    unFold (unFold) {
      this.isFold = !unFold
    },
    // 拖动相关事件
    onmousedown (e) {
      const disX = e.clientX - this.$el.offsetLeft
      const disY = e.clientY - this.$el.offsetTop

      const self = this
      document.onmousemove = function (e) {
        // 计算移动的距离
        const l = e.clientX - disX
        const t = e.clientY - disY
        // 移动当前元素
        self.$el.style.left = l + 'px'
        self.$el.style.top = t + 'px'
      }
      document.onmouseup = function (e) {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-panel{
  display: flex;
  width: 342px;
  //height: 600px;
  position: absolute;
  top: 60px;
  right: 300px;
  -moz-user-select:none;/*火狐*/
  -webkit-user-select:none;/*webkit浏览器*/
  -ms-user-select:none;/*IE10*/
  -khtml-user-select:none;/*早期浏览器*/
  user-select:none;
  z-index: 1;
  .panel-content {
    width: 310px;
    overflow: hidden;
    background: rgba(36, 37, 38, 0.96);
    box-shadow: 1px 2px 2px 0px rgba(0, 0, 0, 0.2);
    border-radius: 12px;
    .header {
      width: 100%;
      height: 46px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 10px;
      cursor: move;
      // border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      &.header-line{
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      }
      .left {
        display: flex;
        align-items: center;
        .line {
          width: 3px;
          height: 16px;
          background: #3883FF;
          border-radius: 2px;
        }
        .title {
          margin-left: 10px;
          font-size: 16px;
          color: $font-colorf;
        }
      }
      .right{
        display: flex;
        width: 51px;
        text-align: right;
        justify-content: space-between;
        flex-direction: row-reverse;
      }
      .anticon{
        font-size: 18px;
        &:hover{
          color: #3883FF;
        }
      }
      .closestatus {
        transform: rotate(-180deg);
        -ms-transform: rotate(-180deg);
        -moz-transform: rotate(-180deg);
        -webkit-transform: rotate(-180deg);
        -o-transform: rotate(-180deg);
      }
    }

    .main{
      height: 562px;
      .divider {
        width: 100%;
        height: 1px;
        background: $bg-color;
        border: 1px solid rgba(255, 255, 255, 0.1);
      }
      .content {
        //height: 511px;
        // overflow-y: auto;
      }
      .footer {
        width: 100%;
        height: 50px;
        bottom: 0px;
        background: $bg-color;
        border-radius: 0px 0px 4px 4px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
      }
    }
  }
}
</style>
